<template>
  <div>
    <vx-card>
      <ListContasBancarias
        :subjectPermission="subjectPermission"
      ></ListContasBancarias>
    </vx-card>
  </div>
</template>

<script>
import ListContasBancarias from "./../../lists/ListContasBancarias";

export default {
  data() {
    return {
      subjectPermission: "Contas Bancárias",
    };
  },
  methods: {},
  components: {
    ListContasBancarias,
  },
};
</script>
